import { GraphQL } from '@guestgoodie/graphql'

export const RoleToLabel = {
  [GraphQL.Role.Admin]: 'Admin',
  [GraphQL.Role.Member]: 'Member',
  [GraphQL.Role.Editor]: 'Editor',
  [GraphQL.Role.Readonly]: 'Readonly',
  [GraphQL.Role.Reception]: 'Reception'
}

export const ROLES = [
  {
    label: RoleToLabel[GraphQL.Role.Admin],
    value: GraphQL.Role.Admin
  },
  {
    label: RoleToLabel[GraphQL.Role.Editor],
    value: GraphQL.Role.Editor
  },
  {
    label: RoleToLabel[GraphQL.Role.Reception],
    value: GraphQL.Role.Reception
  },
  {
    label: RoleToLabel[GraphQL.Role.Member],
    value: GraphQL.Role.Member
  },
  {
    label: RoleToLabel[GraphQL.Role.Readonly],
    value: GraphQL.Role.Readonly
  }
]
